/**
 * @generated
 * This file is generated by scripts/generate-async-query-metadata.js.
 * Do not edit manually.
 * Source: src/ui/search-page-relay/search-results/__generated__/searchResultsAsyncQuery.graphql.ts
 */

export const SEARCH_RESULTS_ASYNC_QUERY_PERSISTED_ID =
	'd86364e7f5d4baf4f0e576b79b4bc94a4fc83c92992a8a1bfd38187dfdcc158b';
export const SEARCH_RESULTS_ASYNC_QUERY_OPERATION_NAME = 'searchResultsAsyncQuery';
